import axios from '@/libs/api.request'

// 查询门店列表
export function storeList(params) {
  return axios.request({
    url: '/franchise/store/list',
    method: 'get',
    params
  })
}

// 查询门店详情
export function storeInfo(storeId) {
  return axios.request({
    url: `/franchise/store/info/${storeId}`,
    method: 'get'
  })
}

// 新增门店
export function addStore(data) {
  return axios.request({
    url: '/franchise/store/save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 修改门店
export function updateStore(data) {
  return axios.request({
    url: '/franchise/store/update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 删除门店
export function delStore(storeIds) {
  return axios.request({
    url: '/franchise/store/delete',
    method: 'post',
    data: storeIds,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
